export const DCF_TEST_IDS = {
  taxRateChip: 'valuation-dcf__tax-rate-chip',
  waccChip: 'valuation-dcf__wacc-chip',
} as const;
